/**
 * 导入工具模块
 */
import { isInApp, isValidJSON } from '../../utils';

/**
 * 导入handler
 */
import { bridgeCallHandler, bridgeRegisterHandler } from '../../core';
import { printNativeMethodFallback } from '../../internal';

/**
 * 导入类型声明
 */
import type { BridgeResponse, BridgeResponseCallback, BridgeUpdateOptions } from '../../types';

/**
 * 注册返回监听事件
 * @param callback
 */
export const setEventWatchCloseWebview = (callback: () => void): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('setEventWatchCloseWebview', 'addEventListenerCloseWebview');
    return;
  }

  bridgeRegisterHandler('addEventListenerCloseWebview', '', callback);
};

/**
 * 调用客户端主题变化事件
 * @param callback
 * @returns
 */
export const setEventWatchThemeChange = (callback: BridgeResponseCallback): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('setEventWatchThemeChange', 'setTheme');
    return;
  }

  bridgeRegisterHandler('setTheme', '', callback);
};

/**
 * 注册更新页面方法
 * @param callback
 */
export const setEventWatchUpdate = (eventName: string, callback: (val: any) => void): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('setEventWatchUpdate', ['refreshPage', 'toRefreshPage']);
    return;
  }

  /**
   * 注册页面更新的handler
   */
  bridgeRegisterHandler('refreshPage', '', (val: string | undefined | null) => {
    if (!val) {
      return;
    }

    /**
     * 获取返回参数
     */
    const data: BridgeUpdateOptions = isValidJSON(val) ? JSON.parse(val) : {};

    /**
     * 触发回调
     */
    if (data.type == 'get' && callback) {
      callback(data.data);
    }
  });

  /**
   * 标记当前更新的标识
   */
  const setData: BridgeUpdateOptions = {
    type: 'set',
    key: eventName,
    data: '',
  };
  const params = JSON.stringify(setData);
  bridgeCallHandler('toRefreshPage', params, null);
};

/**
 * 注册多选图片回调监听事件
 * @param callback
 */
export const setEventWatchMultiChooseImage = (callback: (data: string) => void): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('setEventWatchMultiChooseImage', 'chooseImageMultiCallBack');
    return;
  }

  bridgeRegisterHandler('chooseImageMultiCallBack', '', callback);
};

/**
 * 监听键盘显示隐藏事件，并返回键盘高度
 * @param callback
 * @returns
 */
export const setEventWatchKeyboardVisibilityChange = (callback: (data: BridgeResponse) => void): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('setEventWatchKeyboardVisibilityChange', 'keyboardVisibilityChange');
    return;
  }

  bridgeRegisterHandler('keyboardVisibilityChange', '', callback);
};

/**
 * 监听原生触发提问事件
 * @param callback
 */
export const triggerAIQuestion = (callback: (data: BridgeResponse) => void): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('triggerAIQuestion', 'triggerAIQuestion');
    return;
  }

  bridgeRegisterHandler('triggerAIQuestion', '', callback);
};

/**
 * 注册自选股更新方法
 * @param callback
 */
export const setEventWatchSelfStockChange = (callback: (data: string) => void): void => {
  const isApp: boolean = isInApp();
  if (!isApp) {
    printNativeMethodFallback('setEventWatchSelfStockChange', 'reloadSelfStocks');
    return;
  }
  bridgeRegisterHandler('reloadSelfStocks', '', callback);
};
